/** @jsx jsx */
import { Link } from 'gatsby'
import { Box, Heading, Text, jsx } from 'theme-ui'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'

const FooterCta = () => {
  const translate = useTranslate()

  return (
    <Box>
      <Heading as="h2" variant="title5" mb={2}>
        {translate('footer.cta.title')}
      </Heading>
      <Text as="p" mb={[3, null, 4]} variant="body2">
        {translate('footer.cta.text')}
      </Text>
      <Link to={`/can-club/`} sx={{ variant: 'buttons.secondaryAlt' }}>
        {translate('footer.cta.button')}
      </Link>
    </Box>
  )
}

export default FooterCta
